module.exports = __webpack_public_path__ + "static/media/icon-video-switch.5c9b287a.svg";